module.exports = __webpack_public_path__ + "img/pic-13.15f77156.jpg";